import { useState } from "react";
import { useTranslation } from "react-i18next";
import { History } from "lucide-react";
import { HistoryPanel } from "./HistoryPanel";
import type { HistoryCollection } from "../../../core/history/entities/HistoryVersion";

export interface HistoryTarget {
  collection: HistoryCollection;
  recordId: string;
  /** Titre de l'enregistrement, affiché en sous-titre du panneau. */
  recordLabel?: string;
  /** Appelé après une restauration réussie, pour rafraîchir la page appelante. */
  onRestored?: () => void;
}

/// Bouton discret ouvrant le panneau d'historique des versions.
///
/// Reprend le style des icônes déjà présentes dans l'en-tête de `FormLayout` (copie, aide).
export function HistoryButton({
  collection,
  recordId,
  recordLabel,
  onRestored,
}: HistoryTarget) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        title={t("history.title")}
        aria-label={t("history.title")}
        className="cursor-pointer text-gray-300 transition-colors hover:text-blue-600 dark:text-gray-600 dark:hover:text-blue-400"
      >
        <History className="h-4 w-4" />
      </button>

      {isOpen && (
        <HistoryPanel
          collection={collection}
          recordId={recordId}
          recordLabel={recordLabel}
          onClose={() => setIsOpen(false)}
          onRestored={onRestored}
        />
      )}
    </>
  );
}
